/**
 * React hook that is used to mark the block wrapper element.
 * It provides all the necessary props like the class name.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-block-editor/#useblockprops
 */
// import { useBlockProps } from '@wordpress/block-editor';
import { useBlockProps,
	AlignmentControl,
	RichText,
	InspectorControls,
	PanelColorSettings,
	MediaUpload,
	InnerBlocks
	} from '@wordpress/block-editor';
import { useMemo } from '@wordpress/element';

import ColorPopup from '../Components/ColorPopup';

import {
	PanelBody ,
	PanelRow,
	TextControl,
	__experimentalNumberControl as NumberControl,
	__experimentalBorderBoxControl as BorderBoxControl,
	__experimentalBoxControl as BoxControl,
	RangeControl,
	ToggleControl,
	ColorPalette,
	SelectControl,
	Card,
	CardBody,
	CardHeader,
	TabPanel,
	Flex, FlexBlock, FlexItem,
	} from '@wordpress/components';


import { GLOBAL_FONTS } from '../Global/GLOBAL_FONTS';
import { GLOBAL_FONTS_WEIGHTS } from '../Global/Global_font_weights';
import { GLOBAL_ICONS } from '../Global/Global_Icons';

/**
 * The save function defines the way in which the different attributes should
 * be combined into the final markup, which is then serialized by the block
 * editor into `post_content`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/#save
 *
 * @return {Element} Element to render.
 */
export default function save({attributes}) {
	const {
        type,
        popupDelay,
        buttonColor,
        buttonText,
        buttonTextSize,
        buttonWidth,
        buttonHeight,
        closeButtonPosition,
        textColor,
        textFontFamily

    } = attributes;
	var buttonStyle = {
		backgroundColor: buttonColor,
		padding : buttonHeight+"em "+buttonWidth+"em",
		fontSize: buttonTextSize+"em",
		fontFamily:textFontFamily,
		color: textColor,
	}
	var closeButtonStyle = {
		top:closeButtonPosition.top,
		right:closeButtonPosition.right
	}
	return (
	<div className={'k2-modal-container'} data-type={type} data-time={popupDelay*1000}>
		{
			(type == 'button') &&
			<button className={'k2-modal-button'} style = {buttonStyle}>{buttonText}</button>
		}
		<div className="k2-modal k2-modal-fade-in">
			<div className="k2-modal-content">
				<InnerBlocks.Content />
				<div className="k2-modal-close" style={closeButtonStyle}>&times;</div>
			</div>
		</div>
	</div>
  );
}
